module.exports = __webpack_public_path__ + "static/media/logo_gcp.bd65955c.jpg";